module.exports = __webpack_public_path__ + "media/images/icons/ic-field-service-69e70bd3825957494f11b5e0637c2474.svg";